const KWKModule = {
  namespaced: true,
  state: {
    campaignId: null,
    campaignName: '',
    validationErrorCode: null,
    validationError: null,
    fallBackDashboardError: false,
    fallBackDashboardErrorText: '',
    kwkOrderByLink: false
  },
  getters: {
    campaignId: state => state.campaignId,
    campaignName: state => state.campaignName,
    validationErrorCode: state => state.validationErrorCode,
    validationError: state => state.validationError,
    fallBackDashboardError: state => state.fallBackDashboardError,
    fallBackDashboardErrorText: state => state.fallBackDashboardErrorText,
    kwkOrderByLink: state => state.kwkOrderByLink
  },
  mutations: {
    setCampaignId (state, campaignId) {
      state.campaignId = campaignId
    },
    setCampaignName (state, campaignName) {
      state.campaignName = campaignName
    },
    setValidationErrorCode (state, validationErrorCode) {
      state.validationErrorCode = validationErrorCode
    },
    setValidationError (state, validationError) {
      state.validationError = validationError
    },
    resetValidationError (state) {
      state.validationErrorCode = null
      state.validationError = null
    },
    setFallbackDashboardError (state, validationError) {
      state.fallBackDashboardErrorText = validationError
      state.fallBackDashboardError = true
    },
    resetFallbackDashboardError (state) {
      state.fallBackDashboardError = false
      state.fallBackDashboardErrorText = ''
    },
    setKwkOrderByLink (state, kwkOrderByLink) {
      state.kwkOrderByLink = kwkOrderByLink
    },
    resetState (state) {
      state.campaignId = null
      state.campaignName = ''
      state.validationErrorCode = null
      state.validationError = null
      state.fallBackDashboardError = false
      state.fallBackDashboardErrorText = ''
      state.kwkOrderByLink = false
    }
  }
}

export {
  KWKModule
}
